import client from "utils/api";
import store from 'utils/store'
function saveUser(obj){

}

function getInvoices(){
  return client().get("/subscriptions/invoices").then((response)=>{
    return response.data.invoices
  })
}

function cancelSubscription(){
  return client().delete(`/subscriptions`)
  .then((response) => {
    store.dispatch({type:"UPDATE_USER", payload: response.data})
    store.dispatch({type:"ADD_TOAST", message: "Your subscription is now canceled."})
    return response.data
  })
  .catch(e => {
    //console.log("==>", e.response)
    store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

  });
}

function changeCard(token){
  return client().post(`/subscriptions/cards`, token)
  .then((response) => {
    store.dispatch({type:"UPDATE_USER", payload: response.data})
    store.dispatch({type:"ADD_TOAST", message: "Your card was updated successfully."})
    return response.data
  })
}
function updateUser(model){
  return client().post(`/users/me/edit`, model)
  .then((response) => {
    store.dispatch({type:"UPDATE_USER", payload: response.data})
    store.dispatch({type:"ADD_TOAST", message: "Account updated."})
    return response.data
  })
  .catch(e => {
    //console.log("==>", e.response)
    store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

  });
}


export default {
  cancelSubscription,
  saveUser,
  updateUser,
  changeCard,
  getInvoices,
}



// WEBPACK FOOTER //
// ./src/components/settings/api.js